import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledPublicContent,
  StyledInnerContent,
} from './publicContent.styles';

const PublicContentLayout = ({ children, background = 'primary', login = false, }) => {
  return (
    <StyledPublicContent background={background} login={login}>
      <StyledInnerContent>{children}</StyledInnerContent>
    </StyledPublicContent>
  );
};

PublicContentLayout.propTypes = {
  children: PropTypes.any,
  background: PropTypes.string,
  login: PropTypes.bool,
};

export default PublicContentLayout;
